import React from 'react';
import PropTypes from 'prop-types';
import { BestSellerBadge, TopRatedBadge, MostFavoritedBadge } from './styles/TopRatedBadges.style';

const TopRatedBadges = ({ topRatedBadge, bestSellerBadge, mostFavoritedBadge }) => {
  let res;
  if (topRatedBadge && bestSellerBadge && mostFavoritedBadge) {
    res = (
      <div className="flex-row flex-end top-badge-container">
        {bestSellerBadge && (
          <BestSellerBadge aria-label={`${bestSellerBadge} Badge`} tabIndex="0">
            {bestSellerBadge}
          </BestSellerBadge>
        )}
        {topRatedBadge && (
          <TopRatedBadge aria-label={`${topRatedBadge} Badge`} tabIndex="0">
            {topRatedBadge}
          </TopRatedBadge>
        )}
      </div>
    );
  } else {
    res = (
      <div className="flex-row flex-end top-badge-container">
        {bestSellerBadge && (
          <BestSellerBadge aria-label={`${bestSellerBadge} Badge`} tabIndex="0">
            {bestSellerBadge}
          </BestSellerBadge>
        )}
        {topRatedBadge && (
          <TopRatedBadge aria-label={`${topRatedBadge} Badge`} tabIndex="0">
            {topRatedBadge}
          </TopRatedBadge>
        )}
        {mostFavoritedBadge && (
          <MostFavoritedBadge aria-label={`${mostFavoritedBadge} Badge`} tabIndex="0">
            {mostFavoritedBadge}
          </MostFavoritedBadge>
        )}
      </div>
    );
  }
  return res;
};
TopRatedBadges.propTypes = {
  topRatedBadge: PropTypes.string,
  bestSellerBadge: PropTypes.string,
  mostFavoritedBadge: PropTypes.string,
};
TopRatedBadges.defaultProps = {
  topRatedBadge: '',
  bestSellerBadge: '',
  mostFavoritedBadge: '',
};
export default TopRatedBadges;
